import cx from "classnames";
import * as React from "react";

interface QESWidgetFooterProps {
  className?: string;
}

/**
 * The bottom of the Widget. Renders a gray border above it to create space.
 */
export const QESWidgetFooter: React.FC<React.PropsWithChildren<QESWidgetFooterProps>> = ({
  children,
  className,
}) => {
  return (
    <div className={cx("qes-widget__footer", className)}>
      {children}
    </div>
  );
};
